"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function emitStreamChanged(from, to) {
    var action = function (dispatch, getState) {
        dispatch({
            type: emitStreamChanged.type,
            payload: {
                from: from,
                to: to,
            },
        });
    };
    action.type = emitStreamChanged.type;
    return action;
}
emitStreamChanged.type = "emitStreamChanged";
exports.default = emitStreamChanged;
//# sourceMappingURL=emitStreamChanged.js.map